
/** Directory */
export const GET_DIRECTORY = 'GET_DIRECTORY';
export const GET_DIRECTORY_SUCCESS = 'GET_DIRECTORY_SUCCESS';
export const CREATE_DIRECTORY = 'CREATE_DIRECTORY';
export const EDIT_DIRECTORY = 'EDIT_DIRECTORY'
export const DELETE_DIRECTORY = 'DELETE_DIRECTORY'
